import { getDefaultStore } from "jotai";

import { focusModeAtom } from "../../atoms/uiAtoms";
import { registerCommand } from "./registry";

registerCommand("exitFocusMode", () => {
  const store = getDefaultStore();
  store.set(focusModeAtom, { enabled: false, slotId: null });
});
